import React from "react";
import { DesktopWindows, PhoneIphone, Shield } from "@mui/icons-material";

function DisplayModeChoice({ user, onSelect }) {
  return (
    <main className="display-choice">
      <section className="display-choice__hero">
        <div className="display-choice__brand">
          <span><Shield /></span>
          <div>
            <strong>OWSUR-MATADI</strong>
            <small>Capital Investment</small>
          </div>
        </div>
        <div>
          <p>Bonjour, {user?.full_name || "Agent"}</p>
          <h1>Choisissez votre format d'affichage</h1>
          <span>Vous pourrez changer ce choix depuis l'espace mobile.</span>
        </div>
      </section>

      <section className="display-choice__cards">
        <button type="button" onClick={() => onSelect("desktop")}>
          <DesktopWindows />
          <strong>Format PC</strong>
          <span>Tableaux, filtres avances et navigation administrative classique.</span>
        </button>
        <button type="button" className="is-primary" onClick={() => onSelect("mobile")}>
          <PhoneIphone />
          <strong>Format Mobile</strong>
          <span>Interface terrain compacte, inspiree des ecrans fournis.</span>
        </button>
      </section>
    </main>
  );
}

export default DisplayModeChoice;
